
import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import Loading from './../misc/Loading';
import ModelList from './ModelList';
import models from './../../../../model/model';
import withRouter from '/src/components/misc/withRouter';
// import makes from './../../../../model/makes';

class ModelsComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      models: [],
      loaded: false,
      makeid: props.match.params.makeid,
      hideArchived: true
    };
  }

  UNSAFE_componentWillMount() { // eslint-disable-line camelcase
    models.modelsByMake(this.state.makeid, 1, undefined, ['silhouetteImage', 'make']).then((models) => {
      document.title = `Admin - Nybilinformasjon - ${models?.[0]?.make?.name}`;

      this.setState({
        models: models,
        loaded: true
      });
    });
  }

  toggleShowArchived() {
    this.setState({
      hideArchived: !this.state.hideArchived
    });
  }

  render() {
    if (this.state.loaded) {
      return (
        <section>
          <div className="mf-model">
            <ol className="breadcrumb mf-margin-top-20">
              <li><Link to="/">Forsiden</Link></li>
              <li><Link to="/nybilinformasjon/">Nybilinformasjon</Link></li>
              <li className="active"></li>
            </ol>
            <div className="page-header">
              <div className="pull-right">
                <Link
                  to={`/modeller/${this.state.makeid}/modell/new`}
                  className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}
                >
                  <i className="fa fa-plus" aria-hidden="true"></i> Legg til modell
                </Link>
                &nbsp;
                <button onClick={() => {
                  this.toggleShowArchived();
                }} className="btn btn-info" disabled={this.state.working}>
                  {this.state.hideArchived ? 'Vis arkiverte' : 'Skjul arkiverte'}
                </button>
              </div>
              <h1>Bilmodeller fra <em>{this.state.models[0]?.make.name || this.state.makeid}</em></h1>
            </div>
          </div>

          <ModelList models={this.state.models} hideArchived={this.state.hideArchived} />
        </section>
      );
    }

    return (
      <Loading title="Bilmodeller" text="Laster bilmodeller" />
    );
  }
}

export default withRouter(ModelsComponent);
